import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@questlabs/react-sdk/dist/style.css";
import "normalize.css";
import "./main.scss";
import App from "./App";
import * as Sentry from "@sentry/react";
import * as amplitude from "@amplitude/analytics-browser";
import { posthog } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://affe3587be18545e0b0d04586baf5655@o4505989269749760.ingest.sentry.io/4505989271257088",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/app\.macawhq\.com/,
      /^https:\/\/api\.macawhq\.com/,
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  posthog.init("phc_zndSlIBXHefeEbTWJn42RtuAqC5nr3kjspVFAHbaXoR", {
    api_host: "https://a.macawhq.com",
    ui_host: "https://us.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: false,
  });

  amplitude.init("223e76e5122b99cee40585140c538505", {
    defaultTracking: true,
  });
}

createRoot(document.getElementById("root")!).render(
  import.meta.env.PROD ? (
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  ) : (
    <StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </StrictMode>
  ),
);
